import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEprMaterialType implements BaseEnumType {
  private static allValues: EnumEprMaterialType[] = []; // make sure this is top-most
  
  public static aluminium = new EnumEprMaterialType(0, "Aluminium", "enum_epr_material_type_aluminium");
  public static fibreBasedComposite = new EnumEprMaterialType(1, "FibreBasedComposite", "enum_epr_material_type_fibre_based_composite");
  public static glass = new EnumEprMaterialType(2, "Glass", "enum_epr_material_type_glass");
  public static paperOrCardboard = new EnumEprMaterialType(3, "PaperOrCardboard", "enum_epr_material_type_paper_or_cardboard");
  public static plastic = new EnumEprMaterialType(4, "Plastic", "enum_epr_material_type_plastic");
  public static steel = new EnumEprMaterialType(5, "Steel", "enum_epr_material_type_steel");
  public static wood = new EnumEprMaterialType(6, "Wood", "enum_epr_material_type_wood");
  public static other = new EnumEprMaterialType(7, "Other", "enum_epr_material_type_other");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEprMaterialType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isAluminium() { return this === EnumEprMaterialType.aluminium; }
  public isFibreBasedComposite() { return this === EnumEprMaterialType.fibreBasedComposite; }
  public isGlass() { return this === EnumEprMaterialType.glass; }
  public isPaperOrCardboard() { return this === EnumEprMaterialType.paperOrCardboard; }
  public isPlastic() { return this === EnumEprMaterialType.plastic; }
  public isSteel() { return this === EnumEprMaterialType.steel; }
  public isWood() { return this === EnumEprMaterialType.wood; }
  public isOther() { return this === EnumEprMaterialType.other; }

  public static getValues(): readonly EnumEprMaterialType[] {
    return EnumEprMaterialType.allValues;
  }

  public static getValuesExcept0(): readonly EnumEprMaterialType[] {
    return EnumEprMaterialType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEprMaterialType {
    const found = EnumEprMaterialType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEprMaterialType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEprMaterialType): EnumEprMaterialType {
    const found = name ? EnumEprMaterialType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEprMaterialType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEprMaterialType>): boolean {
    return this.key === other?.key;
  }
}